import { render, staticRenderFns } from "./PreviewFormsNDT.vue?vue&type=template&id=248941e2"
import script from "./PreviewFormsNDT.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsNDT.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports